import { render, staticRenderFns } from "./sidebar_user.vue?vue&type=template&id=221a36b8&scoped=true"
import script from "./sidebar_user.vue?vue&type=script&lang=js"
export * from "./sidebar_user.vue?vue&type=script&lang=js"
import style0 from "./sidebar_user.vue?vue&type=style&index=0&id=221a36b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221a36b8",
  null
  
)

export default component.exports